import Routers from './application/router';
import React from 'react'
import ReactGA from "react-ga4";
import { getBrowserLocales } from './misc/utils';

function App() {
  const language = localStorage.getItem('language')
  const SearchParams = new URLSearchParams(window.location.search)
  const source = SearchParams.get('utm_source')
  const medium = SearchParams.get('utm_medium')
  const campaign = SearchParams.get('utm_campaign')
  if(source && medium && campaign) {
      const objParams = {
          utm_source: source,
          utm_medium: medium,
          utm_campaign: campaign
      }
      localStorage.setItem('utm', JSON.stringify(objParams))
  }
  if(!language) localStorage.setItem('language', getBrowserLocales({languageCodeOnly:true})[0])
  

  // # production
  
  React.useEffect(() => {
    ReactGA.initialize("G-8N8384W646");
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  // # testing
  
  // React.useEffect(() => {
  //   ReactGa.initialize('UA-219754999-1')
  //   ReactGa.pageview(window.location.pathname)
  // },[])
  return (
    <div>
      <Routers />
    </div>
  );
}

export default App;
